import React from "react";
import Sidebar from "../../Sidebar";
import DeshbordBreadcrumb from "../../Breadcrumb/DeshbordBreadcrumb";
import DeshBoardFooter from "../../DeshBoardFooter";
import NewsPaperAddViewDataTable from "./NewsPaperAddViewDataTable";
import { Helmet } from "react-helmet";
import { useAuth } from "../../../../Store/AuthContext";

export default function NewsPaperAddView() {
  const { RendomTokenfetch } = useAuth();

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow"></meta>
      </Helmet>
      <div className="page-wrapper dashboard mm-page mm-slideout" id="mm-0">
        <Sidebar />
        <DeshbordBreadcrumb page1={[{ name: "News Paper Add View" }]} />

        <section className="user-dashboard">
          <div className="dashboard-outer">
            {/* ************Data Table Rows ************* */}

            {RendomTokenfetch && <NewsPaperAddViewDataTable />}
          </div>
        </section>

        <div className="deshboard_footer">
          <DeshBoardFooter />
        </div>
      </div>
    </>
  );
}
